import { cn } from '@/lib/utils';

interface SectionLabelProps {
  children: React.ReactNode;
  required?: boolean;
  className?: string;
}

export const SectionLabel = ({ children, required, className = '' }: SectionLabelProps) => (
  <label className={cn('text-foreground font-extrabold text-base block mb-1.5', className)}>
    {children} {required && <span className="text-primary">*</span>}
  </label>
);
SectionLabel.displayName = 'SectionLabel';
